import { getConversationMessagesById } from "../api/client";

const DEFAULT_LIMIT = 100;
const MAX_CONVERSATIONS_PARALLEL = 4;

/**
 * Carrega todas as mensagens de uma solicitação (paginação via beforeMessageId).
 */
export async function fetchAllConversationMessages(conversationId, { limit = DEFAULT_LIMIT } = {}) {
  const id = Number(conversationId);
  if (!Number.isFinite(id) || id <= 0) return [];

  const collected = [];
  let beforeMessageId = null;

  for (let page = 0; page < 500; page += 1) {
    const opts = { limit, returnRaw: true };
    if (beforeMessageId != null) opts.beforeMessageId = beforeMessageId;

    const payload = await getConversationMessagesById(id, opts);
    const batch = Array.isArray(payload?.messages) ? payload.messages : [];
    if (!batch.length) break;

    collected.push(...batch);

    const pagination = payload?.pagination || {};
    if (!pagination.hasMore) break;

    const nextBefore = pagination.lastMessageId;
    if (nextBefore == null || nextBefore === beforeMessageId) break;
    beforeMessageId = nextBefore;
  }

  return collected.sort((a, b) => (Number(a?.id) || 0) - (Number(b?.id) || 0));
}

/**
 * Busca mensagens de várias solicitações com limite de concorrência.
 */
export async function fetchMessagesForConversations(conversationIds, { onProgress } = {}) {
  const ids = [...new Set(conversationIds.map((id) => Number(id)).filter((n) => Number.isFinite(n) && n > 0))];
  const result = {};
  if (!ids.length) return result;

  let completed = 0;
  let cursor = 0;

  const worker = async () => {
    while (cursor < ids.length) {
      const current = ids[cursor];
      cursor += 1;
      try {
        result[current] = await fetchAllConversationMessages(current);
      } catch {
        result[current] = [];
      }
      completed += 1;
      onProgress?.(completed, ids.length);
    }
  };

  const workers = Array.from(
    { length: Math.min(MAX_CONVERSATIONS_PARALLEL, ids.length) },
    () => worker()
  );
  await Promise.all(workers);

  return result;
}
